import { Location, Producer } from 'types/producer'
import { getCapacityState } from 'utils/producers'
import { store } from 'store/index'
import LatLngBoundsLiteral = google.maps.LatLngBoundsLiteral

/**
 * Filters the producers
 *
 * @param producers
 * @param selectedEnergyTypes
 * @param bounds
 * @param hideFullProducers
 */
export const filterProducers = (
  producers: Producer[],
  selectedEnergyTypes: string[],
  bounds?: LatLngBoundsLiteral,
  hideFullProducers?: boolean
): Producer[] => {
  const { inputs, flows } = store.getState().customer
  const { didSimulation } = flows.simulation

  let filteredProducers = producers.filter((producer) => {
    return selectedEnergyTypes.length === 0 || selectedEnergyTypes.includes(producer.energyType)
  })

  if (hideFullProducers) {
    filteredProducers = filteredProducers.filter((producer) => {
      const capacityState = getCapacityState(producer, inputs.simulation, didSimulation)
      return !capacityState.soldOut
    })
  }

  if (bounds && bounds.north && bounds.west && bounds.south && bounds.east) {
    filteredProducers = filteredProducers.filter((producer: Producer) => {
      return fitBounds(bounds, { lat: producer.coordinates.lat, lng: producer.coordinates.long })
    })
  }

  return filteredProducers
}

/**
 * Checks of the given location fits the map boundaries
 *
 * @param bounds
 * @param pt
 * @returns boolean
 */
const fitBounds = (bounds: LatLngBoundsLiteral, pt: Location): boolean => {
  const { north, east, south, west } = bounds

  const lngs =
    west < east
      ? [[west, east]]
      : [
          [west, 180],
          [-180, east]
        ]

  return ptInSect(pt.lat, south, north) && lngs.some(([lngFrom, lngTo]) => ptInSect(pt.lng, lngFrom, lngTo))
}

/**
 * Checks if given points are in a section
 *
 * @param x
 * @param a
 * @param b
 * @returns boolean
 */
const ptInSect = (x: number, a: number, b: number): boolean => {
  return (x - a) * (x - b) <= 0
}
